import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import '../index.css';
import Footer from "./footer";
import Navbar from "./navbar";
import Product from "./category_components/product";
import Aside from "./category_components/left_panel"; 
import SmolBanner from "./home_components/SmolBanner";
import NextBTN from "./category_components/next_btn";
import "../css/category_products.css";
import "../css/top_banner.css";
import CategorySkeleton from "./components/commonCategorySkeleton";
import baseUrl from "../base_url.js"
import ErrorComponent from "./components/ErrorComponent.jsx";

// Move this outside component to prevent recreation on each render
const getCategoryButtons = (id) => {
    const buttonSets = {
        // "men": [
        //     {name: "View all", value: "any"},  
        //     {name: "Jeans", value: "jeans"},
        //     {name: "T-Shirts", value: "tshirt"},
        //     {name: "trousers", value: "trouser"},
        //     {name: "Hoodies", value: "hood"},
        //     {name: "Sweatshirts", value: "sweat"},
        //     {name: "Jackets", value: "jacket"},
        //     {name: "Shirts", value: "shirts"},
        //     {name: "", value: ""},
        // ],
        // "ladies": [
        //     {name: "View all", value: "any"},
        //     {name: "Jeans", value: "jeans"},
        //     {name: "Tops", value: "tops"},
        //     {name: "Shirts", value: "shirts"},
        //     {name: "trousers", value: "trouser"},
        //     {name: "Cardigans", value: "cardigans" },
        //     {name: "Hoodies & Sweatshirts", value: "sweats"},
        //     {name: "Night Wear", value: "night"},
        //     {name: "Night", value: "linge"},
        //     {name: "", value: ""},
        // ],
        // "kids": [
        //     {name: "View all", value: "any"},
        //     {name: "Jeans", value: "jeans"},
        //     {name: "T-Shirts", value: "tshirt"},
        //     {name: "trousers", value: "trouser"},
        //     {name: "Cardigans", value: "cardigans" },
        //     {name: "Hoodies & Sweatshirts", value: "hoodies"},
        //     {name: "Jackets", value: "jacket"},
        //     {name: "Shirts", value: "shirts"},
        //     {name: "", value: ""},
        //     {name: "", value: ""},
        // ],
        // "home": [
        //     {name: "View all", value: "any"},
        //     {name: "Cooking", value: "cooking"},
        //     {name: "Nightwear", value: "night"},
        //     {name: "Decor", value: "decor"},
        //     {name: "Kitchen", value: "kitchen"},
        //     {name: "Accessories", value: "accessories" },
        // ],
        // "baby": [
        //     {name: "View all", value: "any"},
        //     {name: "Girls", value: "girl"},
        //     {name: "Boys", value: "boy"},
        //     {name: "Shirts", value: "shirts"},
        //     {name: "Sportswear", value: "sports" },
        // ],
        "products" : [
            {name: "View All", value: "any"},
            {name: "Baskets", value: "basket"},
            {name: "Bowls", value: "bowl"},
            {name: "Laundary Basket", value: "laundry"},
            {name: "Matka", value: "matka"},
            {name: "Ladies Side Bag", value: "ladies"},
            {name: "Mobile Bags", value: "mobile"},
            {name: "Tissue Boxes", value: "tissue"},
            // {name: "Baskets", value: "basket"},
        ]
    };
    
    return buttonSets[id] || buttonSets["men"];
};

// Extracted as a separate component with memoization
const MainContentBanner = React.memo(({ page }) => {
    const styles = {
        width: "100%",
        minWidth: "100%",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 500,
    }

    return (
        <div style={styles} className="MainContentBanner">
            <p>View All / <span style={{ color: "red", fontSize: "15px", paddingLeft: "5px", fontWeight: "600" }} className="red">{page}</span> </p>
        </div>
    )
});

const Settings = React.memo(({ handleSort }) => {
    const [showSortOptions, setShowSortOptions] = useState(false);
    
    const toggleSortOptions = () => {
        setShowSortOptions(!showSortOptions);
    };

    return (
        <div className="settings">
           <div className="left">
                <div className="relative">
                    <button onClick={toggleSortOptions}>SORT BY <i className="fa-solid fa-sort"></i></button>
                    {showSortOptions && (
                        <div className="absolute top-full left-0 bg-white shadow-md z-10 w-40 border border-gray-200">
                            <button 
                                className="block w-full text-left px-4 py-2 hover:bg-gray-100" 
                                onClick={() => {
                                    handleSort('lowToHigh');
                                    setShowSortOptions(false);
                                }}
                            >
                                Price: Low to High
                            </button>
                            <button 
                                className="block w-full text-left px-4 py-2 hover:bg-gray-100" 
                                onClick={() => {
                                    handleSort('highToLow');
                                    setShowSortOptions(false);
                                }}
                            >
                                Price: High to Low
                            </button>
                        </div>
                    )}
                </div>
                {/* <button>FILTER & SORT <i className="fa-sharp-duotone fa-solid fa-filters"></i></button> */}
           </div>
           <div className="right"></div>
        </div>
    )
});

// Separated data fetching logic
const fetchCategoryData = async (category) => {
    const response = await fetch(`${baseUrl}api/products/data/${category}`);
    if (!response.ok) {
        throw new Error("Network response was not ok");
    }
    return response.json();
};

function MainContentLeft({ passedFN, originalData }) {
    const { id } = useParams();
    const buttonEls = getCategoryButtons(id);

    return (
        <div className="main_content_left">
            <Aside
                buttons={buttonEls}
                setData={passedFN} 
                originalData={originalData}
            />
        </div>
    )
}

function SmolBannerFilterd(props){

    const styles = {
        background: `url(${props.bg_src})`,
        backgroundPosition : "center" , 
        color : props.color ,
        backgroundSize : "cover"
    }

    function handleClick(e){
        console.log(e.target.value)
        if(e.target.value === "any"){
            props.setData(props.originalData)
        }else{
            console.log(e.target.value)
            props.setData(props.originalData.filter(item => {return(item.category.includes(e.target.value))
            }))
        }
    }

    return(
            <div style={{...styles , maxWidth  : props.maxWidth }} className="smol_banner">
                <h1 className="text-[14px] font-semibold bannerH1" >{props.heading}</h1>
                <h4 className="text-[12px] text-center bannerH4" >{props.support_text}</h4>
                <div className="flex flex-row gap-[10px] filteredBanner">
                    {props.buttons.map((button)=>(
                        <button onClick={handleClick} className="text-black px-2 py-1 bg-white" value={button.value} key={button.value} >{button.text}</button>
                    ))}
                </div>
            </div>
    )
}


const MainContentRight = React.memo(({ data, page, passedFN, originalData }) => {
    const [number, setNumber] = useState(25);
    
    // Function to parse price string (Rs. 999.00) into number
    const parsePrice = (priceString) => {
        if (!priceString) return 0;
        // Extract numeric part from the price string (remove "Rs. " and convert to number)
        return parseFloat(priceString.replace(/[^\d.]/g, ''));
    };
    
    // Sort handler function
    const handleSort = (sortType) => {
        const sortedData = [...originalData].sort((a, b) => {
            const priceA = parsePrice(a.price);
            const priceB = parsePrice(b.price);
            
            if (sortType === 'lowToHigh') {
                return priceA - priceB;
            } else {
                return priceB - priceA;
            }
        });
        
        passedFN(sortedData);
    };
    
    return (
        <div className="main_content_right">
                {
                    page === "Jutexx" && 
                        <SmolBannerFilterd
                            bg_src ="https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/global_campaigns/season_09/ladies/6049a/6049A-3x1-spring-2024.jpg]&scale=size[960]&sink=format[jpeg],quality[80]"
                            color="black"
                            heading="Explore our Collections"
                            support_text="From Everyday Needs to every Home Needs."
                            setData = {passedFN} 
                            originalData = {originalData}
                            buttons={[{text : "Bowl" , value : "bowl"} , {text : "Laundary Storage" , value : "laundary"} , {text : "Baskets" , value : "basket"}]}
                            maxWidth="100%"
                        />
                }
                {
                    page !== "Jutexx" && 
                            <SmolBanner
                                bg_src ="https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/global_campaigns/season_09/ladies/6049a/6049A-3x1-spring-2024.jpg]&scale=size[960]&sink=format[jpeg],quality[80]"
                                color="black"
                                heading="The T-shirt shop starting $399"
                                support_text="From bold graphics to basics: new trending tees for a fashionable update"
                                buttons={[
                                    {href: "/store/ladies", text: "Ladies"}, 
                                    {href: "/store/kids", text: "Kids"}, 
                                    {href: "/store/baby", text: "Kids & baby"}
                                ]}
                                maxWidth="100%"
            />
                }

            <h1>VIEW ALL</h1>
            
            <Settings handleSort={handleSort} />

            <div className="product_div_area">
                {data.slice(0, number).map((item) => (
                    <Product
                        key={item._id}
                        _id={item._id}
                        dataAltImage ={item.image[0].dataAltImage}
                        src = {item.image[0].src}
                        name={item.title}
                        catrgory={item.category}
                        price={item.price}
                        swatches={item.swatches}
                        code={item.articleCode}
                        slug = {item.slug}
                        image = {item.image}
                        description = {item.description}
                        variants = {item.variants}
                    />
                ))}
            </div>
            <NextBTN
                number={number}
                setNumber={setNumber}
                size={data.length}
            />
        </div>
    );
});

function MainContent() {
    const { id } = useParams();
    
    const categoryMap = {
        "men": "men",
        "ladies": "ladies",
        "sport": "sports",
        "kids": "kids",
        "baby": "baby",
        "home": "home",
        "products" : "Jutexx"
    };
    
    const category = categoryMap[id] || "";
    const [filteredData, setFilteredData] = useState([]);

    // Using React Query for data fetching with automatic caching
    const { data, isLoading, error } = useQuery(
        ['products', category], 
        () => fetchCategoryData(category),
        {
            staleTime: 5 * 60 * 1000, // Data considered fresh for 5 minutes
            cacheTime: 30 * 60 * 1000, // Cache kept for 30 minutes
            onSuccess: (data) => {
                const productData = data.data || [];
                setFilteredData(productData);
            }
        }
    );

    // Show skeleton while loading
    if (isLoading) {
        return <CategorySkeleton />;
    }

    // Show error message if fetch failed
    if (error || !data?.data?.length) {
        return <ErrorComponent/>;
    }

    return (
        <div className="page min-h-screen flex">
            {/* <MainContentBanner page={category} /> */}
            <div className="main_content">
                <MainContentLeft 
                    originalData={data.data} 
                    passedFN={setFilteredData} 
                />
                <MainContentRight 
                    data={filteredData} 
                    page={category} 
                    originalData={data.data} 
                    passedFN={setFilteredData} 
                />
            </div>
        </div>
    );
}

function CommonCategory() {
    React.useEffect(() => {
        document.title = "Jutexx | Explore";
    }, []);
    return (
        <div className="error_page overflow-x-hidden max-w-[100vw] min-h-screen flex flex-col">
            <Navbar />
            <MainContent />
            <Footer />
        </div>
    );
}

export default CommonCategory;